import React from 'react';
import { BarChart3, Download, Gamepad2, Library, LogOut, Plus } from 'lucide-react';

const navItems = [
  { value:'home', label:'Início' },
  { value:'library', label:'Biblioteca', icon:Library },
  { value:'stats', label:'Estatísticas', icon:BarChart3 }
];

const Header = ({ user, onLogout, onExport, onAdd, activeView, onNavigate }) => (
  <header className="sticky top-0 z-30 bg-[#0a0d0b]/95 backdrop-blur-xl border-b-4 border-[#5f351a] shadow-[0_3px_0_#1b100a]">
    <div className="app-container h-16 md:h-[72px] flex items-center justify-between gap-6">
      <button onClick={() => onNavigate('home')} className="flex items-center gap-3 shrink-0 text-left">
        <div className="w-10 h-10 rounded-sm border-2 border-lime-200 bg-lime-400 text-black grid place-items-center shadow-[3px_3px_0_#314604]"><Gamepad2 className="w-5 h-5" strokeWidth={2.5} /></div>
        <div><h1 className="pixel-font text-xs md:text-sm font-extrabold text-lime-300 leading-none">Já Joguei</h1><span className="retro-text hidden lg:block text-base text-[#8db5d1] mt-1">Sua vida em jogos</span></div>
      </button>

      <nav className="hidden md:flex items-center self-stretch">
        {navItems.map(item => <button key={item.value} onClick={() => onNavigate(item.value)} className={`relative h-full px-4 text-xs font-bold transition ${activeView === item.value ? 'text-white' : 'text-slate-500 hover:text-slate-300'}`}>{item.label}{activeView === item.value && <span className="absolute bottom-0 inset-x-4 h-0.5 bg-lime-400 rounded-t" />}</button>)}
      </nav>

      <div className="hidden md:flex items-center gap-2 ml-auto">
        <button onClick={onExport} className="icon-button" aria-label="Exportar ranking"><Download className="w-4 h-4" /></button>
        <button onClick={onAdd} className="btn-primary px-4 py-2.5 text-xs flex items-center gap-2"><Plus className="w-4 h-4" /> Adicionar</button>
        <button onClick={onLogout} className="ml-1 w-9 h-9 rounded-full bg-white/[0.07] text-xs font-extrabold text-slate-300 grid place-items-center hover:bg-red-500/15 hover:text-red-300 transition" title={`Sair da conta de ${user.displayName}`}><LogOut className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  </header>
);
export default Header;
